import React, { useRef, useState, useEffect } from 'react';
import { Button, Box } from '@mui/material';

const DescriptionComponent = ({ child, height }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [showButton, setShowButton] = useState(false);

    const divRef = useRef(null);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    useEffect(() => {
        if (divRef.current) {
            divRef.current.style.maxHeight = '100%';
            setShowButton(height < divRef.current.clientHeight);
            divRef.current.style.maxHeight = `${height}px`;
        }
    }, [child]);
    
    return (
        <div>
            <div ref={divRef} style={
                {
                    maxHeight: isExpanded ? '100%' : `${height}px`,
                    overflow: isExpanded ? 'visible' : 'hidden',
                    position: 'relative',
                }}>
                {child}
            </div>
            {showButton ? <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 1 }}>
                <Button sx={{fontSize: 12}} variant="text" onClick={toggleExpand}>
                    {isExpanded ? 'Show Less' : 'Show More'}
                </Button>
            </Box> : null}
        </div>
    );
};

export default DescriptionComponent;
